// extracted by css-extract-rspack-plugin
export default {"wrapper":"_9d21c90c","content":"_af42e1d6"};